const OVERTIME_MULTIPLIER = 1.5;

export default OVERTIME_MULTIPLIER;
